module.exports = "replacing-module4/module";


/*****************
 ** WEBPACK FOOTER
 ** ./resolving/browser-field/~/replacing-module4/module.js
 ** module id = 12
 ** module chunks = 0
 **/